import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { generatePath } from 'react-router-dom';
import { Downgraded, useState } from '@hookstate/core';
import {
    Box,
    // CircularProgress,
    Slide
} from '@mui/material';
import TransportNote from '../Transportation/transportNote';
import SelectTransportation from '../Transportation/selectTransportation';
import { useAuthState } from '../../stores/authStore';
import { useEventState } from '../../stores/eventStore';
import RouteConstants from '../../constants/routeConstants';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import Helper from '../../utility/helper';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import PendingActionDialog from '../../sharedcomponents/confirmationdialog/pendingActionDialog';
import { FULL_PERMISSION, VIEW_PERMISSION, REQUEST_STATUS_LIST } from '../../constants/Constant';
import { NO_ACCESS_PERMISSION } from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import AccordianCommonRequests from '../../sharedcomponents/commonRequest/accordianCommonRequest';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import StyledTable1 from '../../sharedcomponents/styledTable/styleTable1';
import AppConstants from '../../constants/appConstants';
import { RequestStatus } from '../../constants/Constant';
import { isEmpty } from 'lodash-es';
import DataList from '../../sharedcomponents/dataList/dataList';



const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const headers = [
    { key: 'memberName', title: 'Name' },
    { key: 'memberDOB', title: 'Date Of Birth' },
    { key: 'memberContactNo', title: 'Phone' },
    { key: 'relation', title: 'Relation' },
    { key: 'amExLocatorNo', title: 'AmEx Record Locator Number' },
    { key: 'comments', title: 'Additional Comments' },
    { key: 'auditBy', title: 'Audit By' },
    { key: 'auditDate', title: 'Audit Date' },
    { key: 'auditStatus', title: 'Audit Status' },
    { key: 'requestStatus', title: 'Status' }
]

const DraftFlightInfoList = () => {
    
    const showSearch = true;
    const openDialog = useState(false);
    const transittype = useState(null);
    const eventState = useEventState();
    const history = useHistory();
    const authState = useAuthState();
    const loading = useState(false);
    const approveLoader = useState(false);
    const rejectLoader = useState(false)
    const allData = useState();
    const fullData = useState([]);
    const allListData = useState([]);
    const eventData = useState(null);
    const userID = useState(null);
    const openNoteDialog = useState(false);
    const requestNote = useState(null);
    const requestPending = useState(null);
    const filteredList = useState([]);
    const [showHistory, setShowHistory] = React.useState(false);
    const [transportHistory, setTransportHistory] = React.useState()
    const [allNoteValue, setAllNoteValue] = React.useState('')
    const [filters, setFilters] = React.useState(null);
    const statusList = useState(REQUEST_STATUS_LIST);
    const setAll = useState(false);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const [modPermission, setModPermission] = React.useState(null);
    const [filterChangeVal, setFilterChangeVal] = React.useState(false)
    const [participantList, setParticipantList] = React.useState(null);
    const [addedUserIds, setAddedUserIds] = React.useState(null);
    const allNote = useState(false)
    const eventInfo = Helper.getStorage('eventInfo');
    const userInfo = Helper.getStorage('userInfo');
    const agentConnection = Helper.getStorage('agentConnections') ? Helper.getStorage('agentConnections') : Helper.getSessionStorage('agentConnections');
    const displayName = useState(null);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: null,
        noOfPages: null,
    });
    const approveConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const rejectConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });

    const pendingAction = useState({
        open: false,
        title: '',
        message: '',
    });
    const [showStatus, setShowStatus] = React.useState({
        Approved: 0,
        Pending: 0,
        Rejected: 0
    });
    const approveloading = useState({
        loading: false,
        index: 0
    })
    const rejectloading = useState({
        loading: false,
        index: 0
    })

    let eventRole = '';
    if (!isEmpty(eventInfo)) {
        eventRole =
            userInfo && userInfo.roles
                ? userInfo.roles.find(
                    (item) => item.eventID === eventInfo.eventID
                )?.eventRole
                : '';
    }
    useEffect(() => {

        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        if (
            userID.get() == null &&
            (eventData.get() == null ||
                (eventData.get() &&
                    eventData.eventID.value != eventInfo.eventID))
        ) {
            eventData.set(eventInfo);
            eventInfo.moduleDetails.filter((x) => x.moduleID === AppConstants.EVENT_MODULES.DRAFT_FLIGHT_INFO).map((item) => {
                displayName.set(item.displayName)
            })
            userID.set(userInfo.userID);
        }
        if (Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo) || Helper.isEventStaff(userInfo)) {
            setModPermission(FULL_PERMISSION);
        } else {
            setModPermission(VIEW_PERMISSION);
        }
        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        ) {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: authStateInfo.itemsPerPage,
                noOfPages: null,
            });
        }
    }, [authState]);
    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (Helper.isAdminUser(userInfo)) {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: 5000,
                noOfPages: pagingInfo.get().noOfPages,
            });
        }
    }, [])
    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState && eventState.eventDetail.get()) {
            if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo)) {
                setModPermission(FULL_PERMISSION);
            } else if (userInfo.roles && Helper.isEventAdmin(userInfo)) {
                const permissions = eventState.permissions
                    .attach(Downgraded)
                    .get();
                if (permissions && permissions.length > 0) {
                    setModPermission(
                        Helper.getModuleAccessPermission(
                            permissions,
                            'DRAFTFLIGHTINFO'
                        )
                    );
                }
            }
        }
    }, [eventState]);

    useEffect(() => {
        if (modPermission && modPermission != NO_ACCESS_PERMISSION) {
            const pageInfo = pagingInfo.attach(Downgraded).get();
            if (pageInfo.itemsPerPage) {
                getDraftFlightInfoList();
            }
            getParticipantList();
        }
    }, [modPermission]);
    const getDraftFlightInfoList = () => {
        loading.set(true);
        let participantLists = [];
        ApiHelper.get(
            APIURLConstants.GET_DRAFT_FLIGHT_INFO_LIST(
                eventData.get().eventID,
                // agentConnection ? false : userInfo.userType == 'Admin' ? true : false,
                userInfo.userType == 'Admin' || !isEmpty(eventRole)
                    ? true
                    : false,
                userInfo.userID
            )
        )
            .then((res) => {
                if (res.data.rows) {
                    let data = res.data.rows;
                    let requestData = [];
                    let allrequestData = [];
                    const indexOfLastRecord = pagingInfo.get().currentPage * pagingInfo.get().itemsPerPage;
                    const indexOfFirstRecord = indexOfLastRecord - pagingInfo.get().itemsPerPage;
                    // console.log("data",data);
                    if (data.length > 0) {
                        let approved = 0;
                        let pending = 0;
                        let rejected = 0;
                        let addedusers = []
                        data.map((item) => {
                            addedusers.push(item.userID)
                            if (item.requestStatus === RequestStatus.APPROVED) {
                                approved += 1;
                            } else if (item.requestStatus === RequestStatus.PENDING) {
                                pending += 1;
                            } else {
                                rejected += 1
                            }
                            if (
                                participantLists.indexOf(item.participant) == -1
                            ) {
                                participantLists.push(item.participant);
                            }
                            allrequestData.push({
                                actualData: item,
                                row: getColumnNames(item),
                                selected: false,
                                expanded: false,

                            });
                        });
                        setAddedUserIds(addedusers)
                        fullData.set(allrequestData)
                        setFilters({
                            // transportType: ['Air', 'Ground'],
                            participant: participantLists,
                            requestStatus: statusList.attach(Downgraded).get(),
                        });
                        data.slice(indexOfFirstRecord, indexOfLastRecord).map((item) => {
                            requestData.push({
                                actualData: item,
                                row: getColumnNames(item),
                                selected: false,                                
                                expanded: false,
                            });
                        });
                        setShowStatus({ Approved: approved, Pending: pending, Rejected: rejected })
                    } else {
                        setParticipantList(participantList)
                        setShowStatus({ Approved: 0, Pending: 0, Rejected: 0 })
                    }
                    setShowSearchRec(false);
                    let filterData = filteredList.attach(Downgraded).get();
                    if (filterData.length > 0) {
                        setFilterChangeVal(false)
                    }
                    allData.set(allrequestData);
                    allListData.set(allrequestData);
                    loading.set(false);

                    if (pagingInfo.get().noOfPages == null) {
                        pagingInfo.set({
                            ...pagingInfo,
                            currentPage: pagingInfo.get().currentPage,
                            itemsPerPage: pagingInfo.get().itemsPerPage,
                            noOfPages: Math.ceil(
                                res.data.totalCount /
                                pagingInfo.get().itemsPerPage
                            ),
                        });
                    }
                }
            })
            .catch((error) => {
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    alert(error);
                }
            });
    };

    const getColumnNames = (item) => {
        let settingData = [];
        let settingRemainingCount = [];
        if (
            item.flightSetting !== undefined &&
            item.flightSetting.length > 0
        ) {
            const parseData = item.flightSetting[0].setting ? JSON.parse(
                item.flightSetting[0].setting
            ) : null;
            if (
                parseData &&
                parseData.length > 0
            ) {
                const settingParseData = JSON.parse(
                    parseData[0].FlightSetting
                );
                settingData.push(settingParseData);
            }
            settingRemainingCount.push({
                used:
                    Number(
                        item.flightSetting[0]
                            .usedCount
                    )
            });
        }
        let columnArray = [
            {
                label: 'checkbox',
                key: 'flightInfoID',
                flightInfoID: item.flightInfoID,
                width: '0.05',
            },
            {
                key: 'participant',
                participant: item.participant,
                width: '0.22',
                addLink: false,
                toEmail: item.email,
                showEmail: true,
                // alignCenter: true, 
            },
            {
                label: 'Name',
                key: 'memberName',
                memberName: item.memberName,
                width: '0.25',
                inColumn: true,
                // alignCenter: true,
            },
            {
                label: 'Relation',
                key: 'relation',
                relation: item.relation,
                width: '0.15',
                inColumn: true,
                // alignCenter: true,
            },
            {
                label: 'Submitted By',
                key: 'createdByName',
                createdByName: item.createdByName,
                width: '0.23',
                inColumn: true,
                // alignCenter: true,
            },
            {
                label: 'Submitted Date',
                key: 'date',
                date: Helper.FormatDateTime(item.createdDate),
                width: '0.23',
                inColumn: true,
            },
            {
                label: 'FlightAllotment',
                key: 'flightAllotment',
                settingData:
                    settingData.length > 0
                        ? settingData
                        : 0,
                settingRemainingCount:
                    settingRemainingCount.length >
                        0
                        ? settingRemainingCount
                        : 0,
                showLabel: false,
                width: '0.2',
                alignCenter: true,
            },

            {
                label: 'History',
                key: 'auditHistory',
                auditHistory: "",
                width: '0.05',
                showLabel: false,
                showChips: false,
                inColumn: true,
            },

            {
                label: 'Status',
                key: 'requestStatus',
                requestStatus: item.requestStatus,
                width: '0.05',
                showStatusIcon: true,
                inColumn: true,
                alignCenter: true,
            },
            {
                label: 'Action',
                key: 'All',
                all: 'All',
                width: '0.2',
            },
        ];

        return columnArray;
    }

    const filterListData = (data) => {
        filteredList.set(data);
    };
    const callExport = () => {
        if (filteredList.attach(Downgraded).length !== 0) {
            const selected = filteredList
                .get()
                .filter((user) => user.selected === true);
            const allSelected = filteredList
                .get()
                .filter((user) => user.selected === false);

            if (selected.length === 0) {
                generateExcelReport(allSelected);
            } else {
                generateExcelReport(selected);
            }
        } else {
            const selected = allData
                .get()
                .filter((user) => user.selected === true);
            const allSelected = fullData
                .get()
                .filter((user) => user.selected === false);

            if (selected.length === 0) {
                generateExcelReport(allSelected);
            } else {
                generateExcelReport(selected);
            }
        }
    };

    const handleConfirmation = () => {
        let deleteRequests = [];
        allData.get().map((row) => {
            if (row.selected === true) {
                deleteRequests.push(row.actualData.flightInfoID);
            }
        });
        fullData.get().map((row) => {
            if (row.selected === true) {
                deleteRequests.push(row.actualData.flightInfoID);
            }
        });

        ApiHelper.post(APIURLConstants.DELETE_DRAFT_FLIGHT_INFO, {
            flightInfoIDs: deleteRequests.join(','),
            eventModuleID: 0,
            ModifiedBy: userID.value,
        })
            .then((res) => {
                if (res.data) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request deleted successfully',
                    });
                    // onDelete(false);
                    setAll.set(false);
                    getDraftFlightInfoList();
                }
            })
            .catch((error) => {
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };

    const handlePendingAction = () => {
        pendingAction.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
        const req = requestPending.attach(Downgraded).get();
        const updateStatus = {
            flightInfoID: req.flightInfoID,
            status: req.status,
            modifiedBy: req.userID,
            eventID: eventData.get().eventID,
            userID: userInfo.userID,
            note: "",
        };
        ApiHelper.post(
            APIURLConstants.UPDATE_DRAFT_FLIGHT_INFO_STATUS,
            updateStatus
        ).then((res) => {
            if (res.data) {
                rejectloading.set({
                    loading: false,
                    index: 0
                })
                approveloading.set({
                    loading: false,
                    index: 0
                })
                pendingAction.set({
                    open: false,
                    title: '',
                    OkButtonText: 'Ok',
                    message: '',
                });
                requestPending.set(null);
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'success',
                    message: 'Request updated successfully',
                });
                getDraftFlightInfoList();
            }
        });
    };


    const generateExcelReport = async (result) => {
        let selectedIds = [];
        let IDs = null;
        if (result.length > 0) {
            result.map((item) => {
                selectedIds.push(item.actualData.flightInfoID);
            });
            IDs = selectedIds.join(',');
        }

        await ApiHelper.post(
            APIURLConstants.Excel_Export, {
            EventID: eventData.get().eventID,
            ModuleID: AppConstants.EVENT_MODULES.DRAFT_FLIGHT_INFO,
            IDs: IDs
        }
        ).then((res) => {
            const finalObject = JSON.parse(res.data.value);
            if (finalObject) {
                if (finalObject.length > 0) {
                    let header = {};
                    Object.keys(finalObject[0]).map((key) => {
                        header[key] = key;
                    });

                    finalObject.unshift(header);
                    Helper.downloadReport(finalObject, `Flight-Info-Report`);
                }
            }
        });
    };

    const handlePageChange = (event, page) => {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
        getcombineFlightinfoList();
    };

    const getParticipantList = () => {
        const gEventInfo = Helper.getStorage('eventInfo');
        const gUserInfo = Helper.getStorage('userInfo');
        if (
            Helper.isAdminUser(gUserInfo) ||
            (gUserInfo.roles && Helper.isEventAdmin(gUserInfo) || (gUserInfo.roles && Helper.isEventStaff(gUserInfo)))
        ) {
            ApiHelper.get(
                APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
            ).then((res) => {
                if (res.data) {
                    const participants = res.data.rows.filter(
                        (participant) =>
                            AppConstants.EVENT_ROLES_VALUES.indexOf(
                                participant.roleName
                            ) == -1
                    );
                    setParticipantList(participants);
                }
            });
        }
    }

    const onToggleChange = (item, findex) => {
        item.expanded = !item.expanded;

        let index = allData.findIndex(i => i.actualData.draftTransportID === item.actualData.draftTransportID);
        allData[index].set(item);

        let newIndex = fullData.findIndex(i => i.actualData.draftTransportID === item.actualData.draftTransportID);
        fullData[newIndex].set(item);
    }

    const onActionClick = (item, index, action) => {
        if (action == 'Approve') {
            approveloading.set({
                loading: true,
                index: index
            })
        }
        else if (action == 'Reject') {
            rejectloading.set({
                loading: true,
                index: index
            })
        }
        let newData = [...allData.attach(Downgraded).get()];
        let Index = newData.findIndex(
            (data) => data.actualData.flightInfoID == item.actualData.flightInfoID
        );
        let newItem = newData[Index].actualData;

        const isStatus = action == 'Approve' ? 2 : action == 'Reject' ? 3 : 1;
        requestNote.set({
            noteID: newItem.noteID,
            flightInfoID: newItem.flightInfoID,
            status: isStatus,
            userID: newItem.userID,
            action,
            item: newItem,
            index,
            note: "",
        });
        openNoteDialog.set(true);
    };

    const closeNoteDialog = () => {
        approveloading.set({
            loading: false,
            index: 0
        })
        rejectloading.set({
            loading: false,
            index: 0
        })
        openNoteDialog.set(false);
        requestNote.set(null);
    };

    const updateNote = async (value) => {
        let newRequestNote = { ...requestNote.attach(Downgraded).get() };
        newRequestNote['note'] = value;
        newRequestNote['item'].note = value;
        const notesUpdate = {
            flightInfoIDs: newRequestNote.flightInfoID.toString(),
            note: newRequestNote.note,
            Status: newRequestNote.status,
            ModifiedBy: userID.get(),
            eventID: eventInfo.eventID,
            eventModuleID: 0,//TO do - pass event module ID 
            userID: newRequestNote.userID
        };

        ApiHelper.post(
            APIURLConstants.UPDATE_DRAFT_FLIGHT_INFO_STATUS,
            notesUpdate
        )
            .then(async (res) => {
                if (res.data) {
                    approveloading.set({
                        loading: false,
                        index: 0
                    })
                    rejectloading.set({
                        loading: false,
                        index: 0
                    })
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Status updated successfully',
                    });
                    let published = {}
                    participantList.filter((item) => item.userID === newRequestNote.item.userID).map((x) => {
                        published = { isPublished: x.isPublished }
                    })
                    //                 if(published.isPublished){
                    // getEmailNotification(req.draftTransportID);
                    //                 }
                    getDraftFlightInfoList();
                    if (eventData.get().readonlyOrHide === 0 && published.isPublished) {
                        saveAppNotification(newRequestNote);
                    }
                    closeNoteDialog();

                }
            });
    };
    const saveAppNotification = (obj) => {
        let payLoad = {
            appNotificationID: 0,
            userIDs: JSON.stringify(obj.userID),
            appNotificationTypeID: 1,
            eventID: eventData.get().eventID,
            moduleID: AppConstants.EVENT_MODULES.DRAFT_FLIGHT_INFO,
            recordRefID: obj.flightInfoID,
            requestStatus: obj.status,
            status: 0,
            createdBy: userID.get(),
        };
        ApiHelper.post(APIURLConstants.SAVE_APP_NOTIFICATION, payLoad).then(res => {
            console.log(res);
            ApiHelper.get(
                APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
                    obj.item.userID,
                    eventData.get().eventID,
                    eventData.get().eventName,
                    displayName.get(),
                    obj.status === 2 ? RequestStatus.APPROVED : obj.status === 3 ? RequestStatus.REJECTED : RequestStatus.PENDING
                )
            ).then((res) => {
                console.log(res);
            });
        }).catch(err => {
            console.log(err);
        })
    }


    const editRow = (data) => {
        const row = data.actualData;
        const path = generatePath(RouteConstants.DRAFT_EDIT_FLIGHT_INFO, {
            eventID: eventData.eventID.value,
            flightInfoID: row.flightInfoID
        });

        history.push({
            pathname: path,
            state: { flightInfoState: row, participantList: participantList },
        });
    };

    const onAddRequest = () => {
        // console.log("ASasASas");
        const path = generatePath(RouteConstants.DRAFT_CREATE_FLIGHT_INFO, {
            eventID: eventInfo.eventID
        });

        history.push({
            pathname: path,
            state: { addedUserIds: addedUserIds }
        });
        handleAction('air')
        // openDialog.set(true);
    };

    const handleClose = () => {
        openDialog.set(false);
    };
    const hanldeAllNoteValue = (item) => {
        setAllNoteValue(item)
    }
    const onDelete = () => {
        const selected = allData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        const selected1 = fullData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to delete all request?'
                : 'Do you want to delete selected request?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };

    const onPendingAction = (item, index) => {
        if (item.actualData.requestStatus == RequestStatus.APPROVED) {
            approveloading.set({
                loading: true,
                index: index
            })
        }
        else if (item.actualData.requestStatus == RequestStatus.REJECTED) {
            rejectloading.set({
                loading: true,
                index: index
            })
        }
        let newData = [...allData.attach(Downgraded).get()];
        let Index = newData.findIndex(
            (data) => data.actualData.flightInfoID == item.actualData.flightInfoID
        );
        let newItem = newData[Index].actualData;

        const isStatus = 1;
        requestPending.set({
            addedFor: newItem.userID,
            status: isStatus,
            userID: userID.get(),
            flightInfoID: newItem.flightInfoID,
        });

        let message = 'Do you want to move request to pending?';

        pendingAction.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: message,
        });
    };

    const handleAction = (value) => {
        transittype.set(value);
        // console.log("Asdasdas");
        history.push({
            pathname: generatePath(RouteConstants.DRAFT_CREATE_FLIGHT_INFO, {
                eventID: eventData.eventID.value,
            }),
            state: { transitType: value, addedUserIds: addedUserIds },
        });
        openDialog.set(false);
    };
    const renderDialogContent = () => {
        return <StyledTable1 rowHeader={headers}
            data={transportHistory}
        />
    }

    const renderDialogActions = () => {

    }
    const getTransportHistory = (id) => {
        ApiHelper.get(APIURLConstants.GET_DRAFT_FLIGHT_INFO_HISTORY(id))
            .then(res => {
                let arr = []
                res.data.map((item, index, originalArr) => {
                    let previous = originalArr[index - 1]

                    arr.push({
                        actualData: item,
                        row: [
                            {
                                memberName: item.memberName,
                                highlight: index > 0 ? previous?.memberName !== item.memberName ? true : false : false
                            },
                            {
                                memberDOB: item.memberDOB ? Helper.FormatDate(item.memberDOB) : '',
                                highlight: index > 0 ? previous?.memberDOB !== item.memberDOB ? true : false : false
                            },
                            {
                                memberContactNo: item.memberContactNo,
                                highlight: index > 0 ? previous?.memberContactNo !== item.memberContactNo ? true : false : false
                            },
                            {
                                relation: item.relation,
                                highlight: index > 0 ? previous?.relation !== item.relation ? true : false : false
                            },
                            {
                                amExLocatorNo: item.amExLocatorNo,
                                highlight: index > 0 ? previous?.amExLocatorNo !== item.amExLocatorNo ? true : false : false
                            },
                            {
                                comments: item.comments,
                                highlight: index > 0 ? previous?.comments !== item.comments ? true : false : false
                            },

                            {
                                auditBy: item.submittedBy ? item.submittedBy : '',
                                highlight: index > 0 ? previous?.submittedBy !== item.submittedBy ? true : false : false
                            },
                            {
                                auditDate: Helper.FormatDateTime(item.submittedDate),
                                highlight: index > 0 ? previous?.submittedDate !== item.submittedDate ? true : false : false
                            },
                            {
                                auditStatus: item.auditStatus,
                                highlight: index > 0 ? previous?.auditStatus !== item.auditStatus ? true : false : false
                            },
                            {
                                requestStatus: item.requestStatus,
                                highlight: index > 0 ? previous?.requestStatus !== item.requestStatus ? true : false : false
                            },
                        ]
                    })
                })
                // console.log(arr)
                setTransportHistory(arr)
            }).catch(err => {
                console.log(err)
                setTransportHistory([])
            })

    }

    const showTransportHistory = (item) => {
        setShowHistory(true)
        getTransportHistory(item.actualData.flightInfoID)

    }
    const multiApprove = () => {
        const selected = allData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        const selected1 = fullData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to Approve all request?'
                : 'Do you want to Approve selected request?';
            allNote.set(true)
            approveConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    }
    const multiReject = () => {
        const selected = allData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        const selected1 = fullData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to Reject all request?'
                : 'Do you want to Reject selected request?';
            allNote.set(true)
            rejectConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    }

    const handleRejectConfirmation = () => {
        let rejectRequests = [];
        fullData.get().map((row) => {
            if (row.selected === true) {
                rejectRequests.push({
                    userID: row.actualData.userID,
                    iD: row.actualData.flightInfoID,
                    transportType: "DraftFlightInfo"
                });
            }
        });
        const eventInfo = Helper.getStorage('eventInfo');
        rejectLoader.set(true)
        ApiHelper.post(APIURLConstants.UPDATE_MULTI_SELECT_STATUS, {
            Ids: JSON.stringify(rejectRequests), //approveRequests.join(','),
            Status: 3,
            Note: allNoteValue,
            EventID: eventInfo.eventID,
            ModuleID: AppConstants.EVENT_MODULES.DRAFT_FLIGHT_INFO,
            ModifiedBy: userID.value,
            TemplateType: "DraftFlightInfo",
            TransportType: "",
            appNotificationTypeID: 1
        }).then((res) => {
            if (res.data) {
                rejectLoader.set(false)
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'success',
                    message: 'Request rejected successfully',
                });
                setAll.set(false);
                setAllNoteValue('')
                getDraftFlightInfoList();
                // getMultiEmailNotification(multiUsers, rejectRequests, templateType, transportType)
                // if (eventData.get().readonlyOrHide === 0)
                // {
                //     multisaveAppNotification(multiUsers, rejectRequests, 3);
                // }
            }
        })
            .catch((error) => {
                rejectLoader.set(false)

                if (error.response && error.response.status === 401) {
                    let message = 'Access denied';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                } else if (error.response && error.response.status === 502) {
                    let message = 'Request rejected successfully';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: message,
                    });
                } else {
                    let message = 'Error while reject request';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                }
            });
        rejectConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });

    }
    const handleApproveConfirmation = () => {
        let approveRequests = [];

        fullData.get().map((row) => {
            if (row.selected === true) {
                approveRequests.push({
                    userID: row.actualData.userID,
                    iD: row.actualData.flightInfoID,
                    transportType: "DraftFlightInfo"
                });
            }
        });

        const eventInfo = Helper.getStorage('eventInfo');
        approveLoader.set(true)
        ApiHelper.post(APIURLConstants.UPDATE_MULTI_SELECT_STATUS, {
            Ids: JSON.stringify(approveRequests), //approveRequests.join(','),
            Status: 2,
            Note: allNoteValue,
            EventID: eventInfo.eventID,
            ModuleID: AppConstants.EVENT_MODULES.DRAFT_FLIGHT_INFO,
            ModifiedBy: userID.value,
            TemplateType: "DraftFlightInfo",
            TransportType: "",
            appNotificationTypeID: 1
        })
            .then((res) => {
                // console.log("res", res)
                if (res.data) {
                    approveLoader.set(false)
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request approved successfully',
                    });
                    setAll.set(false);
                    setAllNoteValue('')
                    getDraftFlightInfoList();
                }
            })
            .catch((error) => {
                approveLoader.set(false)
                if (error.response && error.response.status === 401) {
                    let message = 'Access denied';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                } else if (error.response && error.response.status === 502) {
                    let message = 'Request approved successfully';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: message,
                    });
                } else {
                    let message = 'Error while approve request';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                }
            });
        approveConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    }


    return (
        <Box className={"virtusoSummaryContentBox"}>
            {
                // loading.get() ? (
                //     <Box style={loader}>
                //         <CircularProgress />
                //     </Box>
                // ) :
                modPermission && modPermission == NO_ACCESS_PERMISSION ? (
                    <UnauthorizedUI showLogout={false} />
                ) : (
                    <DataList
                        // new props
                        data={allData.attach(Downgraded).get()}
                        allData={fullData.attach(Downgraded).get()}
                        editRow={editRow}
                        handleClick={onAddRequest}
                        title={''}
                        loading={loading.get()}
                        buttonTitle={'Add'}
                        deleteRows={onDelete}
                        filterChangeVal={filterChangeVal}
                        showSearch={showSearch}
                        searchLabel={'Search'}
                        showFilter={true}
                        filters={filters}
                        showSearchRec={showSearchRec}
                        setShowSearchRec={setShowSearchRec}
                        onActionClick={onActionClick}
                        showSync={true}
                        showExport={true}
                        showHistory={showTransportHistory}
                        // showSettings={true}
                        callExport={callExport}
                        getResults={getDraftFlightInfoList}
                        pagingInfo={pagingInfo.attach(Downgraded).get()}
                        handlePageChange={handlePageChange}
                        isPage={true}
                        snackBarProps={snackBarProps}
                        setSnackBarProps={setSnackBarProps}
                        onPendingAction={onPendingAction}
                        modPermission={modPermission}
                        filterListData={filterListData}
                        moduleToShow={'Draft Flight Info'}
                        moduleDisplayName={Helper.getModuleName(eventData.get() ? eventData.moduleDetails.get() : [],
                            AppConstants.EVENT_MODULES.DRAFT_FLIGHT_INFO)}
                        showRequestStatus={showStatus}
                        titleHeader='Draft Flight Info'
                        showApproveAndReject={true}
                        multiApprove={multiApprove}
                        multiReject={multiReject}
                        onToggleChange={onToggleChange}
                        approveLoader={approveLoader.get()}
                        rejectLoader={rejectLoader.get()}
                        showShared={false}
                        approveloading={approveloading.get()}
                        rejectloading={rejectloading.get()}
                        windowAccordDataList={true}
                        rowType="draftFlight"
                        windowDataList={true} 
                        hideReject={true}
                        hideApprove={true}
                        moduleVirtusoDataList={true}
                        showVirtusoSelectAll={true}
                    />
                )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {/* {openDialog.get() && (
                <SelectTransportation
                    open={openDialog.get()}
                    title="Select Transportation Type"
                    handleClose={handleClose}
                    handleAction={handleAction}
                />
            )} */}
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() => {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={rejectConfirmation.get().open}
                    message={rejectConfirmation.get().message}
                    OkButtonText={rejectConfirmation.get().OkButtonText}
                    note={allNote}
                    allNoteValue={hanldeAllNoteValue}
                    handleCnfClick={() =>
                        handleRejectConfirmation(rejectConfirmation)
                    }
                    fullWidth={true}
                    onCancelClick={() => {
                        rejectConfirmation.set({
                            ...rejectConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={approveConfirmation.get().open}
                    message={approveConfirmation.get().message}
                    OkButtonText={approveConfirmation.get().OkButtonText}
                    note={allNote}
                    allNoteValue={hanldeAllNoteValue}
                    handleCnfClick={() =>
                        handleApproveConfirmation(approveConfirmation)
                    }
                    fullWidth={true}
                    onCancelClick={() => {
                        approveConfirmation.set({
                            ...approveConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }

            {
                <PendingActionDialog
                    open={pendingAction.get().open}
                    message={pendingAction.get().message}
                    OkButtonText={pendingAction.get().OkButtonText}
                    handleCnfClick={() => handlePendingAction(pendingAction)}
                    onCancelClick={() => {
                        pendingAction.set({
                            ...pendingAction.get(),
                            open: false,
                        });
                        approveloading.set({
                            loading: false,
                            index: 0
                        })
                        rejectloading.set({
                            loading: false,
                            index: 0
                        })
                    }}></PendingActionDialog>
            }
            {openNoteDialog.get() && (
                <TransportNote
                    open={openNoteDialog.get()}
                    title={`${requestNote.get().action} Note`}
                    handleClose={closeNoteDialog}
                    updateNote={updateNote}
                    data={requestNote.attach(Downgraded).get()}
                />
            )}
            {showHistory && <CustomDialog
                TransitionComponent={Transition}
                title={'Transportation History'}
                maxWidth='xl'
                handleClose={() => { setShowHistory(false); setTransportHistory(); }}
                showClose={true}
                open={showHistory}
                fullWidth={true}
                renderContent={renderDialogContent}
                renderActions={renderDialogActions}

            />}
        </Box>
    );
};

export default {
    routeProps: {
        path: RouteConstants.DRAFT_FLIGHT_INFO_ADMIN_LIST,
        component: DraftFlightInfoList,
    },
    name: 'draftFlightInfoList',
};
